/* FansFirst - Guardia de moneda del carrito (Rodrigo Amat, 2026-09-09).
   Cada mercado tiene UNA moneda fija (MEXICO = MXN, el resto = USD) y no hay
   conversion entre ellos. Si un cliente tiene productos en el carrito y cambia
   de moneda, Shopify vacia el carrito del lado servidor y puede quedar una
   "linea fantasma" visual en la moneda anterior (lo que se vio en la demo).
   Fix acordado con el cliente: antes de cambiar de moneda, si hay productos en
   el carrito, se AVISA; si el cliente acepta, se vacia el carrito de forma
   limpia y se cambia. Asi nunca hay carritos con monedas mezcladas.
   Extra: si la pagina se restaura desde el cache del navegador (boton atras)
   con una moneda distinta a la de la sesion, se recarga para no mostrar precios
   viejos. */
(function () {
  var S = window.Shopify || {};
  if (S.designMode) return;

  var renderedCur = (S.currency && S.currency.active) || null;

  function msg() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    if (lang.indexOf('en') === 0) return 'Changing currency will empty your cart so all prices stay in a single currency. Continue?';
    if (lang.indexOf('pt') === 0) return 'Alterar a moeda vai esvaziar seu carrinho para manter todos os precos em uma unica moeda. Continuar?';
    return 'Cambiar de moneda vaciara tu carrito para mantener todos los precios en una sola moneda. Continuar?';
  }

  function targetCurrency(item) {
    var span = item.querySelector('.localization-form__currency');
    if (!span) return null;
    var t = (span.textContent || '').trim().split(/\s+/)[0];
    return t || null;
  }

  function submitCountry(form, iso) {
    var input = form.querySelector('[name="country_code"]');
    if (input) input.value = iso;
    if (typeof form.submit === 'function') form.submit();
  }

  window.addEventListener('click', function (e) {
    var item = e.target && e.target.closest && e.target.closest('.localization-form__list-item[data-value]');
    if (!item) return;
    var form = item.closest('form');
    if (!form) return;
    var iso = item.getAttribute('data-value');
    if (!iso) return;

    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || null;
    var tgt = targetCurrency(item);
    var currencyChanges = tgt ? (tgt !== cur) : true;
    if (!currencyChanges) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (c && c.item_count > 0) {
          if (!window.confirm(msg())) return;
          fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
            .then(function () { submitCountry(form, iso); })
            .catch(function () { submitCountry(form, iso); });
        } else {
          submitCountry(form, iso);
        }
      })
      .catch(function () { submitCountry(form, iso); });
  }, true);

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (c && c.currency && renderedCur && c.currency !== renderedCur) window.location.reload();
      })
      .catch(function () {});
  });
})();
